import React, { useCallback, useReducer, useState, useEffect, useMemo, useRef } from "react";
import { ProspectListFiltersTabs } from "../../../../utils/AllFilterTabs";
import { Popup } from "../../../../../design_system/components/Popup/Popup.jsx";
import { SelectionControl } from "../../../../../design_system/components/SelectionControls/SelectionControl.jsx";
import ConditionalRender from "../../../../../ConditionalRender";
import { prospectListFilterReducer } from "../reducer/prospectsFilterReducer";
import DatePicker, { Calendar } from "react-modern-calendar-datepicker";
import CustomCalendarPicker from "../../../../cta_utils/CalendarPopup"
import { checkValidDateString, dateFormator, datepicker_input_format } from "../../../../utils/dateUtils";
import humanizeString from "../../../../utils/stringUtils";
import { AggregatesListProvider } from "../../DataMineBasedFilters/utils/aggregates_list_context";
import { AggregatesList } from "../../DataMineBasedFilters/utils/AggregatesList";
import { setState } from "../../../../utils/CommonReducer";
import { FilterSuggestionBox } from "../../DataMineBasedFilters/utils/FiltersSuggestionBox";
import { indexOfObject } from "../../../../utils/ArrayUtils";
import { high_conf_sort } from "../reducer/newsFeedFilterReducer";
import { DateInputBox, DateSeparator } from "../../../../input_utils/DateInputBox";
import SelectAllButton from "../../../../input_utils/SelectAllButton";

export const ProspectBasedFilters = ({
    filtersState,
    filtersStateReducer,
    suggestionUrl = "/prospects/prospect_term_search",
    tempFilterReducer = prospectListFilterReducer,
    allFilterTabs,
    ...props
}) => {
    const [tempFiltersState, tempFiltersStateReducer] = useReducer(
        tempFilterReducer,
        { ...filtersState, showsearchedRes: false, isLoading: {submitLoader: false, tagsListLoader: false, loadMoreLoader: false}, allSelect: false, loadMore: false }
    );
    const detectChanges = useRef("")

    useEffect(() => {
        tempFiltersStateReducer({
            type: "SET_STATE",
            payload: {
                aggregatesData: filtersState.aggregatesData
            }
        })
    }, [filtersState.aggregatesData])

    let { aggregatesData, activeFilterTab, allSelect, showsearchedRes} = tempFiltersState;
    let { filtersSelected } = tempFiltersState;
    const mappedKey = activeFilterTab.tab_key
    const filterType = 'include';
    const searchedAggregatesData = tempFiltersState.searchedAggregatesData?.[mappedKey] || []
    const currentAggregatesData = tempFiltersState.aggregatesData?.[mappedKey] || []
    const currentfiltersSelected = filtersSelected[mappedKey] || [];
    useEffect(() => {
        detectChanges.current = showsearchedRes ? "showsearchedRes" : ""
    }, [showsearchedRes])
    const tagsList = useMemo(() => {
        const source = showsearchedRes ? searchedAggregatesData : currentAggregatesData
        let temp_fields = (source || []).map((item) => ({
            ...item,
            is_checked: currentfiltersSelected.includes(item.term),
        }))
        if(temp_fields.length) {
            const hasUncheckedItems = temp_fields.some(item => !item.is_checked);
            const newAllSelect = !hasUncheckedItems;
            if (newAllSelect !== allSelect) setState(tempFiltersStateReducer)({allSelect: newAllSelect});
        }
        if (!showsearchedRes && detectChanges.current === "showsearchedRes")
            temp_fields.sort((a, b) => b.is_checked - a.is_checked)
        if(filtersState.errors?.filtersError)
            setState(filtersStateReducer)({errors: {}})
        return temp_fields
    }, [showsearchedRes, currentfiltersSelected, searchedAggregatesData, currentAggregatesData])
    let select_all_disabled = [...tagsList].length === 0
    const selectAllFilters = () => {
        if(select_all_disabled) return;
        tempFiltersStateReducer({
            type: "SELECT_ALL_FILTER",
            payload: {
                mappedKey: activeFilterTab.tab_key,
                filterType: filterType,
                tagsList: tagsList,
                allSelect: allSelect
            },
        })
    }

    const handleFilterApply = () => {
        filtersStateReducer({
            type: "APPLY_TEMP_FILTERS",
            payload: {
                filtersSelected: tempFiltersState.filtersSelected ,
            },
        });
        handlePopupClose();
    };
    const handlePopupClose = () => {
        filtersStateReducer({
            type: "SET_POPUP",
            payload: { showable: false },
        });
    };
    const handleFilterSubTabs = useCallback((e, tab_key) => {
        e.stopPropagation();
        tempFiltersStateReducer({
            type: "SET_ACTIVE_FILTER_SUB_TAB",
            payload: { activeFilterTabKey: tab_key, allFilterTabs },
        });
    }, [allFilterTabs]);

    const renderActiveFilter = () => {
        if(activeFilterTab.tab_type === "sort_radio"){
            return <SortTypeFilters activeFilterTab={activeFilterTab} currentValue={filtersSelected[activeFilterTab.tab_key]} sortOptions={currentAggregatesData} filterReducer={tempFiltersStateReducer}/>
        }
        return (
            <div className="popup-col flex-1 filter-popup__col--flex">
                <div className="flex justify-between items-center filter-popup__right-header">
                    <span className="body-s filter-popup__count">
                        Displaying {tagsList.length || 0}
                    </span>
                    <ConditionalRender if={activeFilterTab.tab_type !== "sort_radio"}>
                        <SelectAllButton
                            allSelected={allSelect}
                            selectAllFilters={selectAllFilters}
                            select_all_disabled={select_all_disabled} />
                    </ConditionalRender>
                </div>
                <AggregatesListProvider currfilterState={tempFiltersState}
                    setCurrFilterState={tempFiltersStateReducer}
                    isLoading={tempFiltersState.isLoading}
                    filterTab={tempFiltersState.activeFilterTab}
                    allFilterTabs={allFilterTabs} tagsList={tagsList} type={props.type}>
                    <FilterSuggestionBox suggestionUrl={suggestionUrl}
                        filtersState={tempFiltersState}
                        filtersStateReducer={tempFiltersStateReducer}
                        filterTab={tempFiltersState.activeFilterTab}
                        inputClass="an_search_box"
                        style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}
                        lens_style={{ top: 6, left: 8, width: 24, height: 24 }}
                        placeholder={tempFiltersState.activeFilterTab?.search_bar?.placeholder}
                        suggestionRenderer={{ component: AggregatesList }}
                        setShowSearchedRes={(value) => setState(tempFiltersStateReducer)({showsearchedRes: value})}
                    />
                </AggregatesListProvider>
            </div>
        );
    };

    const renderFiltersLeftPane = () => {
        return allFilterTabs.map((tab) => {
            let applied_filter_key = (filtersSelected?.[tab.tab_key]?.length || 0) > 0 ? filtersSelected?.[tab.tab_key]?.length + " selected" : null;
            if(tab.tab_key === 'sort'){
                let indexOfSortFilter = indexOfObject(high_conf_sort, "value", filtersSelected?.[tab.tab_key]?.[0])
                applied_filter_key = high_conf_sort[indexOfSortFilter]?.short_label || high_conf_sort[0].short_label
            }
            const isActive = tempFiltersState.activeFilterTab.tab_key == tab.tab_key;
            return (
                <div
                    key={tab.tab_key + tab.label}
                    className={`body-s-semibold cursor-pointer relative whitespace-nowrap filter-popup__tab${isActive ? ' filter-popup__tab--active body-s-bold' : ''}`}
                    name={tab.tab_key}
                    onClick={(e) => handleFilterSubTabs(e, tab.tab_key)}
                >
                    {tab.label}
                    <ConditionalRender if={applied_filter_key}>
                        <div className="body-s-bold filter-popup__tab-badge">{applied_filter_key}</div>
                    </ConditionalRender>
                </div>
            );
        });
    };

    return (
        <Popup
            name="Filters"
            handleOnClosePopup={handlePopupClose}
            maxWidth={640}
            customContentStyle={{ padding: 0, display: 'flex', flexDirection: 'column' }}
            primaryAction={{
                label: 'Apply',
                onClick: handleFilterApply,
                isLoading: filtersState.loaders?.filtersSubmitLoader,
            }}
            secondaryAction={{
                label: 'Cancel',
                onClick: handlePopupClose,
            }}
            extraAction={{
                label: 'Clear',
                onClick: () => tempFiltersStateReducer({ type: "CLEAR_SELECTED_FILTERS", payload: { allFilterTabs } }),
                style: { color: "var(--color-link-default)" }
            }}
            extraActionClassName="body-s-bold link-default"
        >
            <div className="flex items-stretch flex-1 min-h-0 min-w-0 filter-popup__layout">
                <div className="filter-popup__left-pane">
                    {renderFiltersLeftPane()}
                </div>
                <div className="flex-1 flex flex-col overflow-hidden filter-popup__right-pane">
                    {renderActiveFilter()}
                </div>
            </div>
            <ConditionalRender if={filtersState.errors?.filtersError}>
                <div className="body-s filter-popup__error">
                    {filtersState.errors?.filtersError}
                </div>
            </ConditionalRender>
        </Popup>
    );
};


export const ProspectBasedDateFilter = ({
    filtersState,
    filtersStateReducer,
    tempFilterReducer,
    ...props
}) => {
    const [tempFiltersState, tempFiltersStateReducer] = useReducer(
        tempFilterReducer,
        { ...filtersState }
    );

    const [dateError, setDateError] = useState(null);
    const [calendarStartDate, setCalendarStartDate] = useState(new Date());

    const toggleDropDown = () => filtersStateReducer({
        type: "SET_POPUP",
        payload: { popup: "showDateFilterDropDown", showable: !filtersState.popupsList.showDateFilterDropDown },
    });

    const applyDateRangefilters = () => {
        const { from, to } = tempFiltersState.dateRanges.created_at.value;
        if (!from || !to) {
            setDateError("Select complete date range");
            return;
        }
        setDateError(null);
        filtersStateReducer({
            type: "APPLY_TEMP_FILTERS",
            payload: {
                filtersSelected: tempFiltersState.filtersSelected,
                dateRanges: tempFiltersState.dateRanges
            },
        });
        if (props.filter === "exportReport")
            props.exportReport(tempFiltersState);
        toggleDropDown();
    };

    const isExportReport = props.filter === "exportReport";
    const from = tempFiltersState.dateRanges.created_at.value.from;
    const to = tempFiltersState.dateRanges.created_at.value.to;

    return (
        <Popup
            name={isExportReport ? "Download stats" : "Date filter"}
            handleOnClosePopup={toggleDropDown}
            maxWidth={340}
            primaryAction={{
                label: isExportReport ? "Download" : "Apply",
                onClick: applyDateRangefilters,
            }}
            secondaryAction={{ label: "Cancel", onClick: toggleDropDown }}
            {...(!isExportReport && {
                extraAction: {
                    label: "Clear filter",
                    onClick: () => {
                        filtersStateReducer({ type: "CLEAR_DATE_RANGES" });
                        toggleDropDown();
                    },
                },
            })}
        >
            <div className="flex items-center filter-popup__date-inputs">
                <DateInputBox side="from" from={from} to={to} />
                <DateSeparator />
                <DateInputBox side="to" from={from} to={to} />
            </div>
            <div className="flex justify-center filter-popup__calendar-wrap">
                <CustomCalendarPicker
                    from={from}
                    to={to}
                    calendarStartDate={calendarStartDate}
                    setCalendarStartDate={setCalendarStartDate}
                    selectRange={true}
                    handleDateChange={(val) => {
                        setDateError(null);
                        tempFiltersStateReducer({
                            type: "UPDATE_DATE_RANGE",
                            payload: { key: "created_at", subkey: "value", value: val },
                        });
                    }}
                />
            </div>
            <ConditionalRender if={dateError}>
                <div className="body-s filter-popup__date-error">
                    {dateError}
                </div>
            </ConditionalRender>
        </Popup>
    );
}



const SortTypeFilters = ({
    activeFilterTab,
    sortOptions=[],
    currentValue,
    onChangeCallback,
    ...props
}) => {
    return(
        <div>
            {sortOptions.map((item, index) => {
                const is_checked = (item.value === currentValue[0]) || (currentValue.length === 0 && item.is_default);
                const showSeparator = index === 2;
                return(
                    <React.Fragment key={item.value}>
                        {showSeparator && (
                            <div className="filter-popup__sort-divider" />
                        )}
                        <div className="filter-popup__sort-option">
                            <SelectionControl
                                type="radio"
                                name="sort_option"
                                value={item.value}
                                checked={is_checked}
                                label={item.label}
                                onChange={(e) => {
                                    props.filterReducer({
                                        type: "SELECTED_FILTER",
                                        payload: {
                                            mappedKey: activeFilterTab.tab_key,
                                            selections: [e.target.value],
                                        },
                                    })
                                }}
                            />
                        </div>
                    </React.Fragment>
                )
            })}
        </div>
    )
}
